import { render, staticRenderFns } from "./BlockLeadsDashboard.vue?vue&type=template&id=5420c412&scoped=true&"
import script from "./BlockLeadsDashboard.vue?vue&type=script&lang=js&"
export * from "./BlockLeadsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BlockLeadsDashboard.vue?vue&type=style&index=0&id=5420c412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420c412",
  null
  
)

export default component.exports